module.exports = __webpack_public_path__ + "static/media/task.cde76e53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Navigation/assets/task.svg
// module id = 84
// module chunks = 0